import { render, staticRenderFns } from "./autherZl.vue?vue&type=template&id=1d8735c8&scoped=true"
import script from "./autherZl.vue?vue&type=script&lang=js"
export * from "./autherZl.vue?vue&type=script&lang=js"
import style0 from "./autherZl.vue?vue&type=style&index=0&id=1d8735c8&prod&lang=css"
import style1 from "./autherZl.vue?vue&type=style&index=1&id=1d8735c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8735c8",
  null
  
)

export default component.exports